module.exports = __webpack_public_path__ + "img/grey_044.5712e620.png";